import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { Boundaries } from "@planzone/core";

const initialState: State = [];

function handleRequest(
  state: State,
  unavailability: Boundaries["removeUnavailability"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.unavailability.uuid === unavailability.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { unavailability, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  unavailability: Boundaries["removeUnavailability"]["success"],
): State {
  const index = state.findIndex(
    (req) => req.unavailability.uuid === unavailability.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToSuccess(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { unavailability, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  unavailability: Boundaries["removeUnavailability"]["failure"],
): State {
  const index = state.findIndex(
    (req) => req.unavailability.uuid === unavailability.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { unavailability, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeUnavailabilityRequested]: handleRequest,
    [events.removeUnavailabilitySucceeded]: handleSuccess,
    [events.removeUnavailabilityFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
